import * as React from "react";
const SvgLightbulb = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M12.5 5a.75.75 0 0 0 0 1.5c1.085 0 2 .914 2 2a.75.75 0 0 0 1.5 0C16 6.586 14.414 5 12.5 5Z"
      fill="currentColor"
    />
    <path
      d="M15.5 15.75c0 .698-.409 1.3-1 1.582v1.918a.75.75 0 0 1-.75.75h-.25v.253a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1-.75-.75V20h-.25a.75.75 0 0 1-.75-.75v-1.918a1.75 1.75 0 0 1-1-1.582v-.687a7 7 0 1 1 7 0v.687ZM6.5 9a5.5 5.5 0 0 0 3.08 4.94.75.75 0 0 1 .42.674v1.136c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25v-1.136a.75.75 0 0 1 .42-.673A5.5 5.5 0 1 0 6.5 9Zm4.5 9.5h2v-1h-2v1ZM20.5 8.25a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75Z"
      fill="currentColor"
    />
    <path
      d="M2 9a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 0 1.5h-.75A.75.75 0 0 1 2 9ZM18.985 4.1a.75.75 0 1 0 .75 1.3l.65-.375a.75.75 0 0 0-.75-1.3l-.65.376ZM3.34 14a.75.75 0 0 1 .274-1.024l.65-.375a.75.75 0 0 1 .75 1.299l-.65.375A.75.75 0 0 1 3.34 14ZM19.737 12.6a.75.75 0 1 0-.75 1.299l.65.375a.75.75 0 0 0 .75-1.3l-.65-.374ZM3.34 4a.75.75 0 0 1 1.024-.274l.65.375a.75.75 0 1 1-.75 1.299l-.65-.375A.75.75 0 0 1 3.34 4Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgLightbulb;
